import React from 'react'
import { injectIntl } from 'react-intl';

import * as S from './RegisterWizard.styled'

const ShowSteps = ({ intl, stateWizard }) => {
  const steps = [
    {
      name: intl.messages.register.show_steps.step1,
      description: intl.messages.register.show_steps.step1_description
    },
    {
      name: intl.messages.register.show_steps.step2,
      description: intl.messages.register.show_steps.step2_description
    },
    {
      name: intl.messages.register.show_steps.step3,
      description: intl.messages.register.show_steps.step3_description
    },
    {
      name: intl.messages.register.show_steps.step4,
      description: intl.messages.register.show_steps.step4_description
    }
  ]

  const checkActiveStep = step => stateWizard.activeStep === step

  const checkStatus = step => {
    switch (true) {
      case stateWizard.activeStep === step:
        return 'timeline__step--active'
      case stateWizard.activeStep > step:
        return 'timeline__step--done'
      default:
        return ''
    }
  }

  const handleChangeStep = step => {
    if (stateWizard.activeStep > step) {
      document.querySelector(`#go-step-${step}`).click()
    }
  }

  return (
    <S.ShowSteps>
      <div className="title">{intl.messages.register.show_steps.title}</div>
      <div className="timeline">
        {steps.map((interator, key) => (
          // eslint-disable-next-line
          <div 
            key={key}
            onClick={() => handleChangeStep(key + 1)}
            className={`timeline__step ${checkStatus(key + 1)}`}>
            <div className="timeline__step-indicator"><div className="circle" /></div>
            <div className="timeline__step-text">
              <div className="timeline__step-text-title">
                {interator.name}
              </div>
              <div className={`timeline__step-text-description ${checkActiveStep(key + 1) && 'timeline__step-text-description--show'}`}>
                {interator.description}
              </div>
            </div>
          </div>
        ))}
      </div>
    </S.ShowSteps>
  )
}

export default injectIntl(ShowSteps)